import {px} from './spacing';

export const rounding = {
    xs: px(6),
    sm: px(8),
    md: px(12),
    lg: px(16),
    xl: px(24),
};
